import React, {CSSProperties, useState} from 'react';
import {Dialog, DialogContent} from "@mui/material";
import {Message} from "../../lib/stores/MessageStore";
import Box from "../../Common/Box";
import shadowClient from "../../lib/clients/shadow/shadowClient";
import {Emoji} from "../Emoji";
import {darken, useTheme} from "@mui/material/styles";
import Avatar from "../../Common/Avatar";

const MessageReactions = ({message, open, onClose}: {
    message: Message,
    open: boolean,
    onClose: () => any
}) => {

    // const [saveError, setSaveError] = useState("");
    const theme = useTheme();
    const [reactionIndex, setReactionIndex] = useState(0);

    const handleClose = () => {
        onClose();
        // setSaveError("");
    }
    const backgroundColor = theme.palette.mode === "dark" ? "#393939" : "#efefef";

    return <Dialog
            fullWidth={true}
            maxWidth="sm"
            open={open} onClose={handleClose}

    >
        <DialogContent
                sx={{
                    background: backgroundColor,
                    padding: "6px",
                    minHeight: "200px",
                }}
        >
            <Box row>
                <Box column>
                    {message.reactions.map((reaction, i) => {
                        let optionalStyling: CSSProperties;
                        const selected = i === reactionIndex;

                        if (selected) {
                            optionalStyling = {
                                borderRadius: "4px",
                                backgroundColor: darken(backgroundColor, 0.2),
                            }
                        }

                        return <Box
                                key={i}
                                center
                                row
                                onClick={() => setReactionIndex(i)}
                                sx={{
                                    alignItems: "center",
                                    paddingRight: "4px",
                                    paddingLeft: "4px",
                                    ...optionalStyling
                                }}
                        >
                            <Emoji
                                    selected={i === reactionIndex}
                                    size={36}
                                    emojiStr={reaction.emoji.value}
                            />

                            <Box
                                    sx={{
                                        fontSize: "12px",
                                        fontWeight: "bold",
                                        marginLeft: "2px"
                                    }}
                            >
                                {reaction.userIds.length}
                            </Box>

                        </Box>
                    })}
                </Box>

                <Box
                        column
                        sx={{
                            padding: "5px 10px",
                        }}
                >
                    {message.reactions[reactionIndex].userIds.map((userId) => {
                        const user = shadowClient.userStore.get(userId);

                        return <Box
                                key={userId}
                                row
                                sx={{
                                    marginBottom: "6px",
                                    alignItems: "center",
                                }}
                        >
                            <Avatar user={user}/>
                            <Box
                                    sx={{
                                        marginLeft: "10px",
                                    }}
                                    fontWeight={500}
                            >
                                {/*@todo: this might cause problems if author doesnt exist*/}
                                {user?.username}
                            </Box>
                        </Box>
                    })}

                </Box>
            </Box>
        </DialogContent>

    </Dialog>
};

export default MessageReactions;
